/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { PipeMiddlewareElement } from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import { makeLogger } from '../../../../logger/logger';
import type { PipeMiddlewareNext } from '../../middleware-pipe';
import {getValidatedPrice} from '../../../../components/result-page/new-result-cards/public/product-card/helpers/helpers';

const { debug } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/res-view-item-list-event.ts',
  loggersList: ['debug']
});

export const resViewItemListEvent: PipeMiddlewareElement<MiddlewarePipeDetails, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
): Promise<any> => {
    const searchTab: SearchTab = details.context;
    const response = await next(details);
    const locale = (searchTab.language).toLowerCase() + '_' + (searchTab.country).toUpperCase();

    const products = [];
    let priceValue = 0;
    response.documents.map((product) =>{
        priceValue += getValidatedPrice(product[locale]?.price) || 0;
        return products.push({
          'item_id' : product?.id,
          'item_name' : product[locale]?.title,
          'item_brand': searchTab.appName,
          'item_list_name': 'product_list',
          'item_list_id': '',
          'item_category' : product[locale]?.category?.CT_CAT,
          'item_variant': '',
          'price': product[locale]?.price || '',
          'quantity': 1
        });
    });

    if(products.length > 0) {
      details.context.ViewItemListEventEmitter.emit({
        event: 'view_item_list',
        country: response.country,
        activeTab: searchTab?.parentDataFlux.root.activeTab,
        tabName: searchTab?.tabName,
        value: priceValue || '',
        ecommerce: {
          items: products
        }
      });
    }
    return new Promise(r => r(response));
};
